// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
}

/* app/providers/theme/App.module.css */
.App-module__appContainer--oFG67 {
    display: flex;
    flex: 1;
    overflow: hidden;
    height: calc(100vh - 70px);
    /* 60px — высота Header */
}

.App-module__content--m748d {
    flex: 1;
    overflow-y: auto;
    height: 100%;
    margin: 0 10px;
}

@media (min-width: 700px) {
    .App-module__appContainer--oFG67 {
        display: flex;
        overflow: visible;
        height: auto;
        margin-bottom: 30px;
    }

    .App-module__content--m748d {
        max-width: 900px;
        margin: 0 auto;
    }
}

.App-module__titleBox--ch4JJ {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.App-module__titleBox--ch4JJ>h1 {
    color: var(--color-title);
    font-size: 25px;
    font-weight: 500;
}

.App-module__titleBox--ch4JJ>h1>span {
    color: var(--color-primary-30);
}

.App-module__btnBack--aVXHh {
    text-transform: none !important;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    height: 70px;
    gap: 10px;
    color: var(--color-primary-30) !important;
}

.App-module__alertBox--B54V3 {
    display: flex;
    justify-content: center;
    align-items: center;
}

.App-module__textEmpty--_nYRb {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    height: 70vh;
}

.App-module__textEmpty--_nYRb>p {
    font-size: 25px;
    color: var(--color-text);
    font-weight: 500;
}

@media (max-width: 1370px) {
    .App-module__titleBox--ch4JJ {
        flex-direction: column;
        justify-content: normal;
        align-items: normal;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/providers/theme/App.module.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;AACd;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,OAAO;IACP,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;QACb,iBAAiB;QACjB,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;IAC/B,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,SAAS;IACT,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;IACvB;AACJ","sourcesContent":["body {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n/* app/providers/theme/App.module.css */\r\n.appContainer {\r\n    display: flex;\r\n    flex: 1;\r\n    overflow: hidden;\r\n    height: calc(100vh - 70px);\r\n    /* 60px — высота Header */\r\n}\r\n\r\n.content {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    height: 100%;\r\n    margin: 0 10px;\r\n}\r\n\r\n@media (min-width: 700px) {\r\n    .appContainer {\r\n        display: flex;\r\n        overflow: visible;\r\n        height: auto;\r\n        margin-bottom: 30px;\r\n    }\r\n\r\n    .content {\r\n        max-width: 900px;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n.titleBox {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.titleBox>h1 {\r\n    color: var(--color-title);\r\n    font-size: 25px;\r\n    font-weight: 500;\r\n}\r\n\r\n.titleBox>h1>span {\r\n    color: var(--color-primary-30);\r\n}\r\n\r\n.btnBack {\r\n    text-transform: none !important;\r\n    display: flex;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    height: 70px;\r\n    gap: 10px;\r\n    color: var(--color-primary-30) !important;\r\n}\r\n\r\n.alertBox {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.textEmpty {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-content: center;\r\n    align-items: center;\r\n    height: 70vh;\r\n}\r\n\r\n.textEmpty>p {\r\n    font-size: 25px;\r\n    color: var(--color-text);\r\n    font-weight: 500;\r\n}\r\n\r\n@media (max-width: 1370px) {\r\n    .titleBox {\r\n        flex-direction: column;\r\n        justify-content: normal;\r\n        align-items: normal;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appContainer": `App-module__appContainer--oFG67`,
	"content": `App-module__content--m748d`,
	"titleBox": `App-module__titleBox--ch4JJ`,
	"btnBack": `App-module__btnBack--aVXHh`,
	"alertBox": `App-module__alertBox--B54V3`,
	"textEmpty": `App-module__textEmpty--_nYRb`
};
export default ___CSS_LOADER_EXPORT___;
